import { v4 as uuidv4 } from 'uuid';

export function getUserID() {
    let userID = localStorage.getItem("quiz_user_id");
    if (!userID) {
        userID = uuidv4(); // Generates a unique identifier
        localStorage.setItem("quiz_user_id", userID);
    }
    return userID;
}
